export default "__VITE_ASSET__Yd8vPTq6__"